var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPsychicNochecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4987 17.9166C11.6848 17.9166 13.664 17.0305 15.0966 15.5978C16.5293 14.1652 17.4154 12.186 17.4154 9.99992C17.4154 7.81381 16.5293 5.83464 15.0966 4.40199C13.664 2.96936 11.6848 2.08325 9.4987 2.08325C7.31259 2.08325 5.33342 2.96936 3.90077 4.40199C2.46814 5.83464 1.58203 7.81381 1.58203 9.99992C1.58203 12.186 2.46814 14.1652 3.90077 15.5978C5.33342 17.0305 7.31259 17.9166 9.4987 17.9166Z",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPsychicNochecked);
export default __webpack_public_path__ + "static/media/icon_psychic_nochecked.5d52d13f2120f4c0f9efed5c8b764c02.svg";
export { ForwardRef as ReactComponent };